import React from "react";
import EducationCard from "./EducationCard";

const Education = () => {
  return (
    <div id='education' className='mt-4 text-white'>
      <h1 className='text-2xl font-bold'>Education</h1>
      <p className='font-light text-gray-400'>
        Here is my Education Background
      </p>

      <div className='flex flex-col md:flex-row mt-4 gap-5'>
        <EducationCard
          name='Brac University'
          issued='Sep 2019 - Present'
          desc='Bachelor of Science in Computer Science and Engineering'
          grade='CGPA: 3.9 (Credits Completed: 118 out of 135)'
        />
        <EducationCard
          name='Academia'
          issued='Aug 2018 - Aug 2019'
          desc="A' Levels"
        />
        <EducationCard
          name='Bangladesh International Tutorial'
          issued='May 2016 - Aug 2017'
          desc="O' Levels"
        />
      </div>
    </div>
  );
};

export default Education;
